var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-overlay n-plan" }, [
    _c(
      "div",
      {
        staticClass: "in-content",
        class: { clsng: _vm.Global.tempClosingOverlay },
      },
      [
        _c("div", { staticClass: "head" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "x",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closePlanOverlay.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 22 22",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.4706 2.5L2.5 19.4706",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.4706 19.4706L2.5 2.5",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inner-content" }, [
          _c("div", { staticClass: "lft" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("p", { staticClass: "step-caption ft-bld" }, [
                  _vm._v("Enter information for your new plan"),
                ]),
                _vm._v(" "),
                _c("InputWrapper", {
                  attrs: { placeholder: "Plan name", "max-chars": 12 },
                  model: {
                    value: _vm.Global.newPlanOverlay.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.Global.newPlanOverlay, "name", $$v)
                    },
                    expression: "Global.newPlanOverlay.name",
                  },
                }),
                _vm._v(" "),
                _c("ToggleWrapper", {
                  attrs: {
                    caption: "Subscription model",
                    items: ["Monthly & yearly", "Monthly only", "Yearly only"],
                  },
                  on: { input: _vm.onPresetChange },
                }),
                _vm._v(" "),
                _c("InputWrapper", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.model == "both" || _vm.model == "monthly",
                      expression: "model == 'both' || model == 'monthly'",
                    },
                  ],
                  attrs: {
                    placeholder: "Monthly billed price",
                    "max-chars": 8,
                    hasPriceTag: "",
                    "price-tag-period": "month",
                  },
                  model: {
                    value: _vm.Global.newPlanOverlay.monthlyPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.Global.newPlanOverlay, "monthlyPrice", $$v)
                    },
                    expression: "Global.newPlanOverlay.monthlyPrice",
                  },
                }),
                _vm._v(" "),
                _c("InputWrapper", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.model == "both" || _vm.model == "annualy",
                      expression: "model == 'both' || model == 'annualy'",
                    },
                  ],
                  attrs: {
                    placeholder: "Yearly billed price",
                    "max-chars": 8,
                    hasPriceTag: "",
                    "price-tag-period": "year",
                  },
                  model: {
                    value: _vm.Global.newPlanOverlay.yearlyPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.Global.newPlanOverlay, "yearlyPrice", $$v)
                    },
                    expression: "Global.newPlanOverlay.yearlyPrice",
                  },
                }),
                _vm._v(" "),
                _c("SliderWrapper", {
                  attrs: {
                    caption: "Number of trial day(s)",
                    "starting-num": 30,
                    "range-min": 0,
                    "range-max": 90,
                  },
                  on: { updateSlider: _vm.updateBorderRadius },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "nxt-out",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._m(1)]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col rgt" },
            [
              _c("p", { staticClass: "step-caption ft-bld" }, [
                _vm._v("Preview of your content"),
              ]),
              _vm._v(" "),
              _c("PlanCard", { attrs: { plan: _vm.Global.newPlanOverlay } }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("span", { staticClass: "txt-grt" }, [_vm._v("New subscription plan")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn main txt-blk" }, [
      _c("span", { staticClass: "hvr" }),
      _vm._v(" "),
      _c("span", { staticClass: "txt" }, [_vm._v("Create my plan")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }